/**
 * 新手指引tooltip
 */
import { Button, Tooltip } from "antd";
import styles from "./index.module.less";
import HBIcon from "@/components/HBIcon";
import classNames from "classnames";

/**
 *
 * @param {ReactDOM} children
 * @param {Function} onClose
 * @param {string=} title
 * @param {string=} content
 * @param {string=} overlayClassName
 * @param {string=} width 内容宽度
 * @returns {JSX.Element}
 * @constructor
 */
export default function GuideTooltip({
  children,
  onClose,
  title,
  content,
  overlayClassName,
  width,
  hideAction,
  ...rest
}) {
  return (
    <Tooltip
      color="#298DFF"
      {...rest}
      overlayClassName={classNames(styles.tooltip, overlayClassName)}
      getPopupContainer={(triggerNode) => triggerNode}
      title={
        <div style={{ width }}>
          {title && <div className={styles.title}>{title}</div>}
          {content && <div className={styles.content}>{content}</div>}
          <HBIcon className={styles.icon} type="ic_close" onClick={onClose} />

          {!hideAction && (
            <div className={styles.actions}>
              <Button size={"small"} type={"text"} onClick={onClose}>
                我知道了
              </Button>
            </div>
          )}
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}
